// extracted by mini-css-extract-plugin
export default {"ns_column":"NSColumn_ns_column__7rR2t"};